import React from "react";
import "./LeftDrawer.scss"
import close from "../../assets/close.svg"
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import insta from "../../assets/insta.svg"
import tt from "../../assets/tt.svg"
import fb from "../../assets/fb.svg"
import { setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";
import { setShowLogin } from "../../../../../../../redux/companyDataSlice";
const LeftDrawer = ({ isOpen, setIsOpen }) => {
    const history = useHistory()
    const company = useSelector((state) => state.companyData.company);
    const dispatch = useDispatch()
    const navs = [
        {
            "title": "Home",
            "href": "/"
        }, {
            "title": "Menu",
            "href": "/page/menu"
        }, {
            "title": "Contact",
            "href": "/page/contact"
        },
    ]
    const handleLogout = () => {
        setIsOpen(false)
        sessionStorage.clear()
        localStorage.clear()
        window.location.href = '/menu'
    };
    return (
        <div className="RegalLeftDrawer">
            <div className={`Regal-left-drawer ${isOpen ? 'open' : ''}`}>
                <div className={`Regal-left-drawer-header`}>
                    <img alt="" src={close}
                        onClick={() => {
                            setIsOpen(false)
                        }} />
                </div>
                <div className={`Regal-left-drawer-content`}>
                    {navs.map((page, key) => {
                        return (
                            <div className={`Regal-left-drawer-content-pages`} key={key}
                                onClick={() => {
                                    history.push(page?.href)
                                }}>
                                {page?.title}
                            </div>
                        )
                    })}
                    {window.location.pathname === "/menu" ? localStorage.getItem('isLogged') === 'true' ?
                        <div className={`Regal-left-drawer-content-btn`}
                            onClick={handleLogout}>
                            Log out
                        </div> : <div className={`Regal-left-drawer-content-btn`}
                            onClick={() => {
                                setIsOpen(false)
                                dispatch(setShowLogin(true))
                            }}>
                            Log in
                        </div> : <div className={`Regal-left-drawer-content-btn`}
                            onClick={() => {
                                dispatch(setSelectedOrderType("collection"))
                                history.push("/menu")
                            }}>
                        Click & Collect
                    </div>}
                </div>
                <div className="Regal-left-drawer-bottm">
                    <div className="Regal-left-drawer-bottm-header">
                        ADDRESS
                    </div>
                    <div className="Regal-left-drawer-bottm-item">
                        {company?.City}, {company?.PostZipCode},<br /> {company?.StateProvinceRegion}, {company?.Country}

                    </div>
                    <div className="Regal-left-drawer-bottm-item2">
                        P:  {company?.Phone}
                    </div>
                    <div className="Regal-left-drawer-bottm-item2">
                        E:  {company?.Email}
                    </div>
                </div>
                <div className='Regal-left-drawer-social'>
                    {company?.SocialMedias
                        ?.instagram && company?.SocialMedias
                            ?.instagram !== "" && <img alt='' src={insta}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.instagram, '_blank')
                                }} />}
                    {company?.SocialMedias
                        ?.tiktok && company?.SocialMedias
                            ?.tiktok !== "" && <img alt='' src={tt}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.tiktok, '_blank')
                                }} />}
                    {company?.SocialMedias
                        ?.facebook && company?.SocialMedias
                            ?.facebook !== "" && <img alt='' src={fb}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.facebook, '_blank')
                                }} />}
                </div>

            </div>
        </div>
    )
}
export default LeftDrawer